


























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
// @ts-ignore
import { quillEditor } from 'vue-quill-editor';
// @ts-ignore
import CommonButton from '@/components/common/CommonButton.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';
import DirectoryMenuNavigationDrawer from '@/components/documents/DirectoryMenuNavigationDrawer.vue';

@Component({
  components: {
    quillEditor,
    CommonButton,
    AccountIcon,
    DirectoryMenuNavigationDrawer,
  },
})
export default class DocumentEdit extends Vue {
  public $refs!: {
    quillEditor: any;
  };
  private content = '案件一覧画面のドキュメントです。';
  private menu: boolean = false;
  private c = false;
  private saveCommonButtonColor: string = '#4384f3';
  private editorOption = {
    modules: {
      toolbar: '#toolbar',
    },
  };

  private d() {
    this.$router.push({ name: 'documents2' });
  }

  private customButtonClick(): void {
    const quill = this.$refs.quillEditor.quill;
    const cursolIndex = quill.getSelection();
    if (cursolIndex) {
      quill.insertText(cursolIndex.index, 'test', 'bold', true);
    }
  }
}
